// src/pages/ForgotPassword.jsx

import React, { useState } from "react";
import api from "../api";
import "../theme/design.css";

export default function ForgotPassword() {

  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");

  const sendReset = async () => {
    try {
      await api.post("/forgot-password", { email });
      setMsg("If the email exists, a reset link has been sent.");
    } catch (e) {
      setMsg("Failed to send reset email.");
    }
  };

  return (
    <div className="page">
      <div className="post-card">

        <h2>Forgot Password</h2>

        <input
          className="input"
          placeholder="Enter your email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
        />

        <button className="btn" onClick={sendReset}>
          Send Reset Link
        </button>

        {msg && <div style={{marginTop:10}}>{msg}</div>}

      </div>
    </div>
  );
}